// extracted by mini-css-extract-plugin
export default {"button":"Coupons_button__bFsDo"};